// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tutorial_TrackResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Tutorial_TrackResponseDados {
tutorial_progress_id?: string
tutorial_progress_user_id?: string
tutorial_progress_slug?: string
tutorial_progress_status?: string
tutorial_progress_step_reached?: number
tutorial_progress_replay_count?: number
tutorial_progress_started_at?: string
tutorial_progress_completed_at?: string
}

export type Tutorial_TrackResponse = ApiResponse<Tutorial_TrackResponseDados>;

registerResponseContract('Tutorial_TrackResponse', {
  tutorial_progress_id:           { type: 'string',  required: false },
  tutorial_progress_user_id:      { type: 'string',  required: false },
  tutorial_progress_slug:         { type: 'string',  required: false },
  tutorial_progress_status:       { type: 'string',  required: false },
  tutorial_progress_step_reached: { type: 'number',  required: false },
  tutorial_progress_replay_count: { type: 'number',  required: false },
  tutorial_progress_started_at:   { type: 'string',  required: false },
  tutorial_progress_completed_at: { type: 'string',  required: false },
})
